import { range, interpolateHsl } from 'd3';

const mainColor = '#0047BB'; // blue
const highlightColor = '#2DCCD3'; // teal
const otherColor = '#F3F3F3'; // smoke

const volumeBarColor = '#BDC2C6'; // 40% gray
const positiveBarColor = '#0FACE7'; //sky
const negativeBarColor = '#DEE1E2'; // 20% gray

const qualitativeColors = [
  // '#E5D555', '#0047BB', '#050139', '#8C959B', '#F68D2E', '#65BD18', '#00A9E0',
  '#050139', // Navy
  '#0DCCD3', // Teal
  '#F44821', // Orange
  '#008000', // Green
  '#DECA2B', // Gold
  '#5060F6', // Iris
  '#5B6770', // Gray
  '#0FACE7', // Sky
  '#ACBCC9', // Silver
  '#F44821', // Orange
  '#373461', // 80% Navy
  '#3DD6DC', // 80% Teal
  '#E5D555', // 80% Gold
  '#7380F8', // 80% Iris
  '#7C858D', // 80% Gray
  '#3FBDEC', // 80% Sky
  '#BDC9D4', // 80% Silver
  '#F66D4D', // 80% Orange
  '#696788', // 60% Navy
  '#6EE0E5', // 60% Teal
  '#6691D6', // 60% Blue
  '#EBDF80', // 60% Gold
  '#96A0FA', // 60% Iris
  '#9DA4A9', // 60% Gray
  '#6FCDF1', // 60% Sky
  '#CDD7DF', // 60% Silver

  '#0047BB', // Blue
];

const timelineColors = [mainColor].concat(qualitativeColors);

const divergingColors = range(0, 16 / 15, 1 / 15).map(
  interpolateHsl('#050139', '#E6E5EB')
); // interpolation of 12 blue Grays

export {
  qualitativeColors,
  timelineColors,
  divergingColors,
  otherColor,
  mainColor,
  highlightColor,
  volumeBarColor,
  positiveBarColor,
  negativeBarColor,
};
